import React from 'react';
import {Avatar, Button, Modal} from "antd";
import {formatPhoneNumber} from '../../../utils/helper'

function CreatorModal({visible, creator,  closeModal}) {
      return (
            <Modal
                  footer={null}
                  visible={visible}
                  maskClosable={false}
                  closable={false}
                  centered
                  className='modal-general modal-creator-info'
            >
                  <div className="head-modal">
                        <div className='left'>
                              <p className="title">Creator info</p>
                        </div>
                        <Button onClick={() => closeModal()}>Close</Button>
                  </div>
                  <div className="body-modal">
                        {creator &&
                              <div className="detail">
                                    <div className="left">
                                          <Avatar src={(creator.profilePicURL && creator.profilePicURL.original) ? creator.profilePicURL.original : "/images/photoSesh-logo-no-slogan.png"} />
                                    </div>
                                    <div className="right">
                                          <p>
                                                <span>Name</span>
                                                <span>{`${creator.name.firstName} ${creator.name.lastName}`}</span>
                                          </p>
                                          <p>
                                                <span>Email</span>
                                                <span>{creator.emailId}</span>
                                          </p>
                                          <p>
                                                <span>Phone</span>
                                                <span>{formatPhoneNumber(creator.phoneNumber) ? formatPhoneNumber(creator.phoneNumber) : creator.phoneNumber}</span>
                                          </p>
                                          <p>
                                                <span>Address</span>
                                                <span>{creator.address}</span>
                                          </p>
                                    </div>

                              </div>
                        }

                  </div>
            </Modal>
      );
}

export default CreatorModal;


// WEBPACK FOOTER //
// ./src/components/Booking/Include/Creator.js